import { cn } from "@newxsystems/shared";
import { DaylightCardLink } from "../DaylightCardLink/DaylightCardLink";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => {
  const Heading = headingAs;
  return (
    <div
      className={cn("grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2", columns[columnCount || 3])}
    >
      {items.map((item, index) => (
        <DaylightCardLink className="overflow-visible border-0" key={index} link={item.cardLink}>
          <DaylightMedia
            aspectRatio={imageAspectRatio || "16:9"}
            imageClassName="transition-transform duration-300 ease-out group-hover:scale-[1.015]"
            media={item.image.image}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
          <div className="mt-5 border-t border-cobalt/20 px-1 pt-5">
            <Heading className="font-daylight-display text-2xl font-semibold leading-tight transition-colors group-hover:text-primary">
              {item.heading}
            </Heading>
            {item.description ? (
              <DaylightRichText
                className="mt-3 text-base text-basalt md:text-lg"
                content={item.description}
              />
            ) : null}
          </div>
        </DaylightCardLink>
      ))}
    </div>
  );
};

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
